import { render } from "./carScreen.vue?vue&type=template&id=31c23b92&scoped=true"
import script from "./carScreen.vue?vue&type=script&lang=js"
export * from "./carScreen.vue?vue&type=script&lang=js"

import "./carScreen.vue?vue&type=style&index=0&id=31c23b92&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c23b92"]])

export default __exports__